<ngb-alert *ngIf="showedAlert" [type]="alert.type" (close)="closeAlert()">{{ alert.message }}</ngb-alert>

<form class="form" [formGroup]="changePasswordForm" autocomplete="off">
	<div class="form-group">
		<mat-form-field *ngIf="!isReset">
			<mat-label class="mat-label">{{ 'AUTH.CHANGE_PASSWORD.CURRENT' | translate }}</mat-label>
			<input matInput type="password" placeholder="{{ 'AUTH.CHANGE_PASSWORD.CURRENT' | translate }}" [type]="hide ? 'password' : 'text'" formControlName="currentPassword" autocomplete="off" />
			<mat-icon class="mat-icon-rtl-mirror md-2" matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
			<mat-error *ngIf="isControlHasError('currentPassword','required')">
				<strong>{{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}</strong>
			</mat-error>
			<mat-error *ngIf="isControlHasError('currentPassword','minLength')">
				<strong>{{ 'AUTH.VALIDATION.MIN_LENGTH_FIELD' | translate }} 3</strong>
			</mat-error>
		</mat-form-field>
		<mat-form-field>
			<mat-label class="mat-label">{{ 'AUTH.CHANGE_PASSWORD.NEW' | translate }}</mat-label>
			<input matInput type="password" placeholder="{{ 'AUTH.CHANGE_PASSWORD.NEW' | translate }}" [type]="hide ? 'password' : 'text'" formControlName="newPassword" autocomplete="off" />
			<mat-icon class="mat-icon-rtl-mirror md-2" matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
			<mat-error *ngIf="isControlHasError('newPassword','required')">
				<strong>{{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}</strong>
			</mat-error>
			<mat-error *ngIf="isControlHasError('newPassword','minLength')">
				<strong>{{ 'AUTH.VALIDATION.MIN_LENGTH_FIELD' | translate }} 3</strong>
			</mat-error>
		</mat-form-field>
		<ng-container *ngFor="let rule of listRules">
			<p style="margin: 0px">
				<ng-container *ngIf="rule.value">
					<mat-icon class="isok">check_circle</mat-icon>
				</ng-container>
				<ng-container *ngIf="!rule.value">
					<mat-icon style="color: lightgray">check_circle</mat-icon>
				</ng-container>
				<mat-label class="mat-label">{{ rule.textRule }}</mat-label>
			</p>
		</ng-container>
		<mat-form-field>
			<mat-label class="mat-label">{{ 'AUTH.CHANGE_PASSWORD.RETYPE' | translate }}</mat-label>
			<input matInput type="password" placeholder="{{ 'AUTH.CHANGE_PASSWORD.RETYPE' | translate }}" [type]="hide ? 'password' : 'text'" formControlName="retypePassword" autocomplete="off" />
			<mat-icon class="mat-icon-rtl-mirror md-2" matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
			<mat-error *ngIf="isControlHasError('retypePassword','required')">
				<strong>{{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}</strong>
			</mat-error>
			<mat-error *ngIf="isControlHasError('retypePassword','minLength')">
				<strong>{{ 'AUTH.VALIDATION.MIN_LENGTH_FIELD' | translate }} 3</strong>
			</mat-error>
		</mat-form-field>
	</div>
	<!--begin::Action-->
	<div class="actions">
		<button mat-raised-button color="btnprimary" (click)="submit()" style="margin-right: 12px" [ngClass]="{'kt-spinner kt-spinner--center kt-spinner--md kt-spinner--light': loader}" [disabled]="loader">
            &nbsp;
            <ng-container *ngIf="!loader">
                {{ 'AUTH.CHANGE_PASSWORD.SUBMIT_BUTTON' | translate }}
            </ng-container>
            &nbsp;
		</button>
		<button mat-raised-button color="btnwhite" *ngIf="isReset || isExpired" routerLink="/auth/login" style="margin-left: 12px">
			&nbsp;
            <ng-container>
				{{ 'AUTH.CHANGE_PASSWORD.CANCEL_BUTTON' | translate }}
			</ng-container>
            &nbsp;
		</button>
	</div>
	<!--end::Action-->
</form>
